import { render, staticRenderFns } from "./ConvenzioniCategory.vue?vue&type=template&id=d0f7e5a2&"
import script from "./ConvenzioniCategory.vue?vue&type=script&lang=js&"
export * from "./ConvenzioniCategory.vue?vue&type=script&lang=js&"
import style0 from "./ConvenzioniCategory.vue?vue&type=style&index=0&id=d0f7e5a2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports